import {NgIf} from '@angular/common';
import {Component, ElementRef, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {ClientEnvService} from '../../core/services/client-env.service';
import {PopupManagerService} from '../../core/services/popup-manager.service';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {UsersOnlineService} from '../../editor-interface/toolbar/users-online.service';
import {FirebaseDataService} from '../../editor-state/firebase-data.service';
import {GraphModeService} from '../../editor-state/graph-mode.service';
import {ModeDataService} from '../../editor-state/mode-data.service';
import {EditorRegistryService} from '../mx-graph/editor/editor-registry.service';
import {EditorUiService} from '../mx-graph/editor/editor-ui.service';
import {EditorService} from '../mx-graph/editor/editor.service';
import {SfaHeaderComponent} from '../sfa-header/sfa-header.component';
import {DiagramCanvasService} from './diagram-canvas.service';
import {SfaHeaderService} from '../sfa-header/sfa-header.service';

@Component({
  selector: 'app-diagram-canvas',
  templateUrl: 'diagram-canvas.component.html',
  styleUrls: ['diagram-canvas.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [NgIf, SfaHeaderComponent]
})
export class DiagramCanvasComponent implements OnInit {
  showHeader = !environment.NOUI;
  constructor(
    private elementRef: ElementRef,
    private editor: EditorService,
    private editorUI: EditorUiService,
    private registry: EditorRegistryService,
    private diagramCanvasSvc: DiagramCanvasService,
    private modeDataSvc: ModeDataService,
    private graphModeSvc: GraphModeService,
    private fbSvc: FirebaseDataService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private popupSvc: PopupManagerService,
    private clientEnvSvc: ClientEnvService,
    private route: ActivatedRoute,
    private usersOnlineSvc: UsersOnlineService,
    private sfaHeaderService: SfaHeaderService
  ) {
    registry.initMxResources();
  }

  ngOnInit() {
    const drawingArea = this.elementRef.nativeElement.querySelector('.graph-drawing-area');
    const Editor = new this.editor.q9Editor(drawingArea, false);
    const EditorUI = new this.editorUI.editorUI(Editor, drawingArea);
    const graph = EditorUI.editor.graph;

    this.registry.setEditorUI(EditorUI);
    this.diagramCanvasSvc.setMain(graph, Editor, EditorUI);

    if (environment.NOUI) {
      return this.prepareGraphForScreenshot(graph);
    }

    this.diagramJsonSvc.setup();
    this.diagramJsonSvc.setupActivityChanges();
    this.setupModeEvents();
  }

  private setupModeEvents() {
    this.modeDataSvc
      .init()
      .onEdit(() => {
        this.graphModeSvc.set(true);
      })
      .onView(() => {
        this.popupSvc.closeAll();
        this.graphModeSvc.set(false);
      })
      .onAny(() => {
        this.usersOnlineSvc.setupUsers();
        this.diagramJsonSvc.setup();
        this.diagramJsonSvc.setupActivityChanges();
      })
      .subscribe();
  }

  private prepareGraphForScreenshot(graph) {
    const json = this.route.snapshot.data.noui;

    this.graphModeSvc.set(false);
    this.diagramCanvasSvc.drawFromJson(json).then(() => {
      const originalBounds = graph.getGraphBounds();

      this.adjustZoomForScreenshot(originalBounds, graph);
      graph.container.style.overflow = 'hidden'; // Apply styles to container only after all zooms done
      console.log('READYFORSHOT');
    });
  }

  private adjustZoomForScreenshot(bounds, graph): void {
    /*
      Differenet numbers here were got in experimental way.
      680x445 - was chosen as the minimum original bounds to ignore adjusting zoom.
      1.4 - is the minimum zoom.
      We increase it by 0.01 for every 25 px in width difference and 37 for height.
      Then we choose bigger of options and apply it as zoom.
       */
    if (bounds.width === 0 || bounds.height === 0) {
      return;
    }

    if (bounds.width <= 680 && bounds.height <= 445) {
      const wOpt = 1.4 + (680 - bounds.width) / 2500;
      const hOpt = 1.4 + (445 - bounds.height) / 3700;
      const zoomValue = wOpt >= hOpt ? wOpt : hOpt;

      // fit() to center image properly and then zoomTo() to adjust to desired zoom
      graph.fit();
      graph.zoomTo(zoomValue);

      return;
    }

    graph.fit();
  }
}
